import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>{
    return{
        btnStyle: {
            color: '#333',
            backgroundColor: '#fff',
            borderRadius: '30px',
        }
    }
})